import { useQuery } from 'react-query'
import { useUser } from '../../../hooks/useUser'
import { api } from '../../../services/api'

export function useMeusChamados(filters = {}) {
  const { codigo_usuario } = useUser()

  const { prioridade = '', concluido = '' } = filters

  const { data, isLoading, error, refetch } = useQuery(
    ['meusChamados', codigo_usuario, prioridade, concluido],
    async () => {
      if (!codigo_usuario) return []

      let url = `/site/v2/crm-controle/listar-chamados-usuario/${codigo_usuario}`

      // Adicionar parâmetros opcionais se estiverem presentes
      const params = []
      if (concluido) params.push(`concluido=${concluido}`)
      if (prioridade) params.push(`prioridade=${prioridade}`)

      if (params.length > 0) {
        url += `?${params.join('&')}`
      }

      const response = await api.get(url)
      return response.data
    },
    {
      refetchOnWindowFocus: true,
      staleTime: 1000 * 60, // 1 minuto
      enabled: !!codigo_usuario, // Só executa se tiver o código do usuário
    }
  )

  return {
    chamados: data || [],
    isLoading,
    error,
    refetch,
  }
}
